import React, { Proptypes } from 'react';

import data from '../../../../core/data';
import cx from 'classnames';

const BlogWrapper = (props) => {
  return (
    <div className="blog">
      <div className={ cx({"container-fluid": props.fluid, "container": !props.fluid })}>
        <h1>{ props.heading }</h1>
        { props.children }
      </div>
    </div>
  )
}

export default BlogWrapper;



/** WEBPACK FOOTER **
 ** ./src/components/containers/news/blogs/BlogWrapper.jsx
 **/